<template>
  <el-dialog
    title="设置商户结算账户"
    :visible.sync="dialogVisible"
    width="70%"
    :before-close="handleClose">
    <el-form ref="form" :model="form" label-width="120px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="账户名" prop="legalPerson" :rules="{ required: true, message: '请输入账户名称', trigger: 'blur' }">
            <el-input v-model="form.legalPerson" placeholder="对私填银行卡姓名 对公填公司全称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="账户证件号" prop="legalPersonIdcard" :rules="{ required: true, message: '请输入证件号 对私填身份证 对公填营业执照号', trigger: 'blur' }">
            <el-input v-model="form.legalPersonIdcard" placeholder="对私填身份证 对公填营业执照号"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="账户号" prop="accountNo" :rules="{ required: true, message: '请输入账户号', trigger: 'blur' }">
            <el-input v-model="form.accountNo" placeholder="请输入账户号"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="账户类型" prop="accountType">
            <el-radio-group v-model="form.accountType">
              <el-radio label="PRI">对私</el-radio>
              <el-radio label="PUB">对公</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="开户地区" prop="bankArea" :rules="{ required: true, message: '请输入开户地区', trigger: 'blur' }">
            <div>{{form.bankProvince}}{{form.bankCity}}</div>
            <el-cascader ref="cascader" v-model="form.bankArea" placeholder="请选择开户地区" :options="areaDatas">
            </el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
          <el-col :span="8">
            <el-form-item label="开户行" prop="bankName" :rules="{ required: true, message: '请输入开户行', trigger: 'blur' }">
              <el-select v-model="form.bankName" filterable placeholder="选择所属银行">
                <el-option
                  v-for="item in bankData"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="支行名称" prop="bankBranchName" :rules="{ required: true, message: '请输入支行名称', trigger: 'blur' }">
              <el-input v-model="form.bankBranchName" placeholder="请输入支行名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="结算方式" prop="settType">
            <el-radio-group v-model="form.settType">
              <el-radio label="TAX">扣税</el-radio>
              <el-radio label="INVOICE">开发票</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="结算费率">
            <el-input v-model="defaultConfig.settRate" placeholder="结算费率" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="结算定额">
            <el-input v-model="defaultConfig.settFixed" placeholder="结算定额" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="结算税点">
            <el-input v-model="defaultConfig.settTax" placeholder="结算税点" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="最低结算金额">
            <el-input v-model="defaultConfig.settMinAmount" placeholder="最低结算金额" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="hideDialog">取 消</el-button>
      <el-button type="primary" @click="submitSet">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import {fetchMerchantAccountInfoUpdate} from '../../api/xunyou';
import bankData from '../../../static/bank/bank'
export default {
  name: 'merchantSettleAdd',
  props: {
    defaultConfig: Object | String
  },
  data() {
    return {
      dialogVisible: false,
      bankData: bankData,
      form: {
        legalPerson: '',
        legalPersonIdcard: '',
        accountType: 'PRI', // PRI-对私 PUB- 对公
        accountName: '',
        accountNo: '',
        bankName: '',
        bankArea: [],
        bankProvince: '',
        bankCity: '',
        bankBranchName: '',
        bankBranchNo: '',
        settType: 'TAX', // TAX-扣税点,INVOICE-开发票
        settFeeRate: '',
        settFeeFixed: '',
        settTax: '',
        settMinAmount: '',
        settPeriod: 0
      },
      rules: {}
    }
  },
  computed: {
    areaDatas () {
      return this.$store.state.getprovince;
    }
  },
  methods: {
    handleClose (done) {
      this.$refs.form.resetFields();
      done();
    },
    showDialog (data) {
      if (data) {
        Object.assign(this.form, data);
      }
      this.dialogVisible = true;
    },
    hideDialog () {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
    },
    submitSet () {
      this.$refs.form.validate(valid => {
        if(this.form.accountType === 'PUB' && this.form.legalPerson.length < 5) {
          this.$message.error('账户名称不合法，对公账户请填写公司全称')
          return false
        }
        if (valid) {
          const bankArea = this.$refs.cascader.getCheckedNodes()[0];
          console.log('bankArea======>>>', bankArea);
          const params = {
            mid: this.$store.state.userInfo.mid,
            legalPerson: this.form.legalPerson,
            legalPersonIdcard: this.form.legalPersonIdcard,
            accountType: this.form.accountType, // PRI-对私 PUB- 对公
            accountName: this.form.legalPerson,
            accountNo: this.form.accountNo,
            bankName: this.form.bankName,
            bankProvince: bankArea.pathLabels[0],
            bankCity: bankArea.pathLabels[1],
            bankBranchName: this.form.bankBranchName,
            bankBranchNo: this.form.bankBranchNo,
            settType: this.form.settType, // TAX-扣税点,INVOICE-开发票
            settFeeRate: this.defaultConfig.settRate,
            settFeeFixed: this.defaultConfig.settFixed,
            settTax: this.defaultConfig.settTax,
            settMinAmount: this.defaultConfig.settMinAmount,
            settPeriod: 0
          };
          this.loading = true;
          fetchMerchantAccountInfoUpdate(params).then(res => {
            console.log('结算账户设置：', res);
            this.loading = false;
            if (res.code === 0) {
              this.hideDialog();
              this.$emit('refresh');
            }
          });
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
/deep/ .el-cascader{
  width: 525px;
}
</style>



// WEBPACK FOOTER //
// src/views/siteNavigation/merchantSettleAdd.vue